<template>
  <div>
    <v-row>
      <v-col cols="6">
        <h1 class="headline font-weight-light mb-3">
          <router-link class="link-a" :to="'/Inventory/Issue'">
            View DocumentReturnDefective</router-link
          >
          / PRINT
        </h1>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="6" class="text-right">
        <v-btn rounded small @click="print()">
          <v-icon class="mr-1" dark small>mdi-printer</v-icon>
          Print</v-btn
        >
      </v-col>
    </v-row>
    <div id="printDiv">
      <!-- ที่เขียน inline เพราะ css ไม่ยอมทำงานตอนปริ้น -->
      <div align="center" class="style2">
        <br />
        <br /><!-- 
        <div align="right">
            <span style="font-size: 15px;font-weight:bold;">เลขที่เอกสาร DOC20060355</span>
            <input type="hidden" id="no_doc" name="no_doc" value="DOC20060355">
            <input type="hidden" id="id_no_doc" name="id_no_doc" value="1">
        </div>
        <br> -->
        <div>
          <div align="center" style="font-size: 30px;font-weight:bold;">
            Please Complete and Return With Your Defective Part
          </div>

          <div
            style="margin-left:70px;font-size:45px;font-family:cursive;font-weight:bold;"
          >
            <label>PLEASE FILL ME OUT</label>
            <img
              style="margin-left:125px;margin-top:-20px;"
              src="../Itservice/hp.jpg"
              height="75"
              width="85"
            />
          </div>
          <div
            style="margin-top:-10px;margin-left:-65px;font-size: 34px;font-weight:bold;font-family: cursive;"
          >
            We value your Feedback!
          </div>
          <br />
          <div>
            <label
              style="margin-top:-10px;font-size: 20px;font-family: cursive;"
            >
              Please fil out the form below and include with the returned part.
              This failure detail is critical for
            </label>
            <label
              style="font-size: 20px;font-family: cursive;margin-top:-10px"
            >
              helping our Repair Technician identify and correct the failure
              experienced.
            </label>
          </div>
          <br />
          <div
            style="margin-top:-10px;margin-left:50px;margin-right:50px;font-size: 20px;font-weight:bold;border:1px solid black;padding:10px;"
            align="left"
          >
            Notebook Unit Serial Number :
          </div>

          <div
            align="left"
            style="margin-top:5px;margin-left:58px;font-weight:bold;font-size: 18px;"
          >
            Return Status:
          </div>
          <div align="left" style="margin-left:126.5px;">
            <label style="font-weight:bold;font-size: 18px;margin-top:-50px;"
              >Good:
            </label>
            <label style="font-weight:bold;font-size: 18px;">[</label
            ><label style="margin-left:20px;font-weight:bold;font-size: 18px;"
              >]</label
            >
            <label style="margin-left:300px;font-weight:bold;font-size: 20px;"
              >Wrong shipment [ ]</label
            >
          </div>
          <div align="left" style="margin-left:179px;margin-top:-10px;">
            <label style="font-weight:bold;font-size: 18px;">[</label
            ><label style="margin-left:20px;font-weight:bold;font-size: 18px;"
              >]</label
            ><label style="font-size:17px;margin-left:5px;"
              >Proactive swap out due to TCE</label
            >
          </div>

          <div align="left" style="margin-left:126px;">
            <label style="font-weight:bold;font-size: 18px;">Bad: </label>
            <label style="font-weight:bold;font-size: 18px;margin-left:13px;"
              >[</label
            ><label style="margin-left:19px;font-weight:bold;font-size: 17px;"
              >]</label
            >
            <label style="font-size:18px;font-weight: 400;margin-left:5px;"
              >Permanent: Time to Failure______ Min/Hrs/day
            </label>
          </div>
          <div align="left" style="margin-left:180px;margin-top:-10px;">
            <label style="font-weight:bold;font-size: 18px;">[</label
            ><label style="margin-left:19px;font-weight:bold;font-size: 18px;"
              >]</label
            >
            <label style="font-size:18px;font-weight: 400;margin-left:5px;"
              >DOA
            </label>
          </div>
          <div align="left" style="margin-left:180px;margin-top:-10px;">
            <label style="font-weight:bold;font-size: 18px;">[</label
            ><label style="margin-left:19px;font-weight:bold;font-size: 18px;"
              >]</label
            >
            <label style="font-size:18px;font-weight: 400;margin-left:5px;"
              >Intermittent: Freq of failure is every _____Min/Hrs/Day
            </label>
          </div>
          <div align="left" style="margin-left:58px;margin-top:5px;">
            <label style="font-size: 20px;font-weight:bold;"
              >Failure description:</label
            >
            <label style="margin-left:5px;"
              >Based on failure confirmation, please tick one or more then add
              comments in Comment Section</label
            >
          </div>
          <div align="left" style="margin-left:125px;">
            <label style="font-weight:400;font-size:18px;">M01</label
            ><label style="font-weight:bold;font-size: 18px;margin-left:19px;"
              >[</label
            ><label style="margin-left:20px;font-weight:bold;font-size: 18px;"
              >]</label
            ><label style="font-size:18px;font-weight: 400;margin-left:5px;"
              >No Video</label
            >
          </div>
          <div align="left" style="margin-left:125px;margin-top:-10px;">
            <label style="font-weight:400;font-size:18px;">M02</label
            ><label style="font-weight:bold;font-size: 18px;margin-left:19px;"
              >[</label
            ><label style="margin-left:20px;font-weight:bold;font-size: 18px;"
              >]</label
            ><label style="font-size:18px;font-weight: 400;margin-left:5px;"
              >Dim display</label
            >
          </div>
          <div align="left" style="margin-left:125px;margin-top:-10px;">
            <label style="font-weight:400;font-size:18px;">M03</label
            ><label style="font-weight:bold;font-size: 18px;margin-left:19px;"
              >[</label
            ><label style="margin-left:20px;font-weight:bold;font-size: 18px;"
              >]</label
            ><label style="font-size:18px;font-weight: 400;margin-left:5px;"
              >Unstable Display or Flickering or Rolling Video</label
            >
          </div>
          <div align="left" style="margin-left:125px;margin-top:-10px;">
            <label style="font-weight:400;font-size:18px;">M04</label
            ><label style="font-weight:bold;font-size: 18px;margin-left:19px;"
              >[</label
            ><label style="margin-left:20px;font-weight:bold;font-size: 18px;"
              >]</label
            ><label style="font-size:18px;font-weight: 400;margin-left:5px;"
              >Color Related Problem</label
            >
          </div>
          <div align="left" style="margin-left:125px;margin-top:-10px;">
            <label style="font-weight:400;font-size:18px;">M05</label
            ><label style="font-weight:bold;font-size: 18px;margin-left:19px;"
              >[</label
            ><label style="margin-left:20px;font-weight:bold;font-size: 18px;"
              >]</label
            ><label style="font-size:18px;font-weight: 400;margin-left:5px;"
              >Bright or Dark Line defect</label
            >
          </div>
          <div align="left" style="margin-left:125px;margin-top:-10px;">
            <label style="font-weight:400;font-size:18px;">M06</label
            ><label style="font-weight:bold;font-size: 18px;margin-left:19px;"
              >[</label
            ><label style="margin-left:20px;font-weight:bold;font-size: 18px;"
              >]</label
            ><label style="font-size:18px;font-weight: 400;margin-left:5px;"
              >Bright or Dark spots</label
            >
          </div>
          <div align="left" style="margin-left:125px;margin-top:-10px;">
            <label style="font-weight:400;font-size:18px;">M07</label
            ><label style="font-weight:bold;font-size: 18px;margin-left:19px;"
              >[</label
            ><label style="margin-left:20px;font-weight:bold;font-size: 18px;"
              >]</label
            ><label style="font-size:18px;font-weight: 400;margin-left:5px;"
              >White screen / White display</label
            >
          </div>
          <div align="left" style="margin-left:125px;margin-top:-10px;">
            <label style="font-weight:400;font-size:18px;">M08</label
            ><label style="font-weight:bold;font-size: 18px;margin-left:19px;"
              >[</label
            ><label style="margin-left:20px;font-weight:bold;font-size: 18px;"
              >]</label
            ><label style="font-size:18px;font-weight: 400;margin-left:5px;"
              >Defective/Bad Pixels</label
            >
          </div>
          <div align="left" style="margin-left:125px;margin-top:-10px;">
            <label style="font-weight:400;font-size:18px;">M09</label
            ><label style="font-weight:bold;font-size: 18px;margin-left:19px;"
              >[</label
            ><label style="margin-left:20px;font-weight:bold;font-size: 18px;"
              >]</label
            ><label style="font-size:18px;font-weight: 400;margin-left:5px;"
              >LCD panel image persistence / Burn-in</label
            >
          </div>
          <div align="left" style="margin-left:125px;margin-top:-10px;">
            <label style="font-weight:400;font-size:18px;">M10</label
            ><label style="font-weight:bold;font-size: 18px;margin-left:19px;"
              >[</label
            ><label style="margin-left:20px;font-weight:bold;font-size: 18px;"
              >]</label
            ><label style="font-size:18px;font-weight: 400;margin-left:5px;"
              >Poor Focus or Resolution</label
            >
          </div>
          <div align="left" style="margin-left:125px;margin-top:5px;">
            <label style="font-weight:400;font-size:18px;">M11</label
            ><label style="font-weight:bold;font-size: 18px;margin-left:19px;"
              >[</label
            ><label style="margin-left:20px;font-weight:bold;font-size: 18px;"
              >]</label
            ><label style="font-size:18px;font-weight: 400;margin-left:5px;"
              >Camera fault (if fitled)</label
            >
          </div>
          <div align="left" style="margin-left:125px;margin-top:-10px;">
            <label style="font-weight:400;font-size:18px;">M12</label
            ><label style="font-weight:bold;font-size: 18px;margin-left:19px;"
              >[</label
            ><label style="margin-left:20px;font-weight:bold;font-size: 18px;"
              >]</label
            ><label style="font-size:18px;font-weight: 400;margin-left:5px;"
              >Light fault (if fitled)</label
            >
          </div>
          <div align="left" style="margin-left:125px;margin-top:-10px;">
            <label style="font-weight:400;font-size:18px;">M13</label
            ><label style="font-weight:bold;font-size: 18px;margin-left:19px;"
              >[</label
            ><label style="margin-left:20px;font-weight:bold;font-size: 18px;"
              >]</label
            ><label style="font-size:18px;font-weight: 400;margin-left:5px;"
              >Microphone problem</label
            >
          </div>
          <div align="left" style="margin-left:125px;margin-top:-10px;">
            <label style="font-weight:400;font-size:18px;">M14</label
            ><label style="font-weight:bold;font-size: 18px;margin-left:19px;"
              >[</label
            ><label style="margin-left:20px;font-weight:bold;font-size: 18px;"
              >]</label
            ><label style="font-size:18px;font-weight: 400;margin-left:5px;"
              >Speaker problem</label
            >
          </div>
          <div align="left" style="margin-left:125px;margin-top:-10px;">
            <label style="font-weight:400;font-size:18px;">M15</label
            ><label style="font-weight:bold;font-size: 18px;margin-left:19px;"
              >[</label
            ><label style="margin-left:20px;font-weight:bold;font-size: 18px;"
              >]</label
            ><label style="font-size:18px;font-weight: 400;margin-left:5px;"
              >Finger print reader problem</label
            >
          </div>
          <div align="left" style="margin-left:125px;margin-top:-10px;">
            <label style="font-weight:400;font-size:18px;">M16</label
            ><label style="font-weight:bold;font-size: 18px;margin-left:19px;"
              >[</label
            ><label style="margin-left:20px;font-weight:bold;font-size: 18px;"
              >]</label
            ><label style="font-size:18px;font-weight: 400;margin-left:5px;"
              >Touch screen problem</label
            >
          </div>
          <div align="left" style="margin-left:125px;margin-top:-10px;">
            <label style="font-weight:400;font-size:18px;">M17</label
            ><label style="font-weight:bold;font-size: 18px;margin-left:19px;"
              >[</label
            ><label style="margin-left:20px;font-weight:bold;font-size: 18px;"
              >]</label
            ><label style="font-size:18px;font-weight: 400;margin-left:5px;"
              >Antenna assembly problem</label
            >
          </div>
          <div align="left" style="margin-left:125px;margin-top:5px;">
            <label style="font-weight:400;font-size:18px;">M18</label
            ><label style="font-weight:bold;font-size: 18px;margin-left:19px;"
              >[</label
            ><label style="margin-left:20px;font-weight:bold;font-size: 18px;"
              >]</label
            ><label style="font-size:18px;font-weight: 400;margin-left:5px;"
              >Display is marked or scratched</label
            >
          </div>
          <div align="left" style="margin-left:125px;margin-top:-10px;">
            <label style="font-weight:400;font-size:18px;">M19</label
            ><label style="font-weight:bold;font-size: 18px;margin-left:19px;"
              >[</label
            ><label style="margin-left:20px;font-weight:bold;font-size: 18px;"
              >]</label
            ><label style="font-size:18px;font-weight: 400;margin-left:5px;"
              >Broken plastics</label
            >
          </div>
          <div align="left" style="margin-left:125px;margin-top:-10px;">
            <label style="font-weight:400;font-size:18px;">M20</label
            ><label style="font-weight:bold;font-size: 18px;margin-left:19px;"
              >[</label
            ><label style="margin-left:20px;font-weight:bold;font-size: 18px;"
              >]</label
            ><label style="font-size:18px;font-weight: 400;margin-left:5px;"
              >Broken Hinge</label
            >
          </div>
          <div align="left" style="margin-left:125px;margin-top:-10px;">
            <label style="font-weight:400;font-size:18px;">M21</label
            ><label style="font-weight:bold;font-size: 18px;margin-left:19px;"
              >[</label
            ><label style="margin-left:20px;font-weight:bold;font-size: 18px;"
              >]</label
            ><label style="font-size:18px;font-weight: 400;margin-left:5px;"
              >Broken Latch</label
            >
          </div>
          <div align="left" style="margin-left:125px;margin-top:-10px;">
            <label style="font-weight:400;font-size:18px;">M22</label
            ><label style="font-weight:bold;font-size: 18px;margin-left:19px;"
              >[</label
            ><label style="margin-left:20px;font-weight:bold;font-size: 18px;"
              >]</label
            ><label style="font-size:18px;font-weight: 400;margin-left:5px;"
              >Other Physical
              Damage__________________________________________</label
            >
          </div>
          <div align="left" style="margin-left:125px;margin-top:5px;">
            <label style="font-weight:400;font-size:18px;">M23</label
            ><label style="font-weight:bold;font-size: 18px;margin-left:19px;"
              >[</label
            ><label style="margin-left:20px;font-weight:bold;font-size: 18px;"
              >]</label
            ><label style="font-size:18px;font-weight: 400;margin-left:5px;"
              >Replaced due to service and engineering advisory</label
            >
          </div>
          <div align="left" style="margin-left:125px;margin-top:5px;">
            <label style="font-weight:400;font-size:18px;">M24</label
            ><label style="font-weight:bold;font-size: 18px;margin-left:19px;"
              >[</label
            ><label style="margin-left:20px;font-weight:bold;font-size: 18px;"
              >]</label
            ><label style="font-size:18px;font-weight: 400;margin-left:5px;"
              >Other__________________________________________</label
            >
          </div>
          <div align="left" style="margin-left:58px;margin-top:5px;">
            <label style="font-size: 20px;font-weight:bold;">Comments:</label>
            <br />
            <label style="margin-left:50px;"
              >________________________________________________________________________________________________________________________</label
            >
            <br />
            <label style="margin-left:50px;"
              >________________________________________________________________________________________________________________________</label
            >
            <br />
            <label style="margin-left:50px;"
              >________________________________________________________________________________________________________________________</label
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import { mapState, mapMutations } from "vuex";
import VueHtmlToPaper from "vue-html-to-paper";

const options = {
  name: "_blank",
  specs: ["fullscreen=no", "titlebar=no", "scrollbars=no"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
  ],
};

export default {
  mounted() {},
  ...mapMutations(["mutateMiniSidebar"]),
  methods: {
    print() {
      this.$htmlToPaper("printDiv");
    },
  },
  data() {
    return {
      data_print: [],
    };
  },
};
</script>
<style scoped>
body {
  margin: 0 !important;
}
</style>
